"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmallBusinessElectricity = function IconSmallBusinessElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m22 8-.003 11.005A3.73 3.73 0 0 1 19 22.942V43H9.27a24 24 0 0 1-2.267-2H17V22.938a3.75 3.75 0 0 1-1.71-.84l-.161-.149-.111-.112q-.062.068-.127.134a3.81 3.81 0 0 1-2.742 1.116l-.138-.007-.134.01a3.74 3.74 0 0 1-2.632-.939l-.163-.153a4 4 0 0 1-.327-.375c-.905.816-2.2 1.323-3.537 1.373L5 23v-2c1.499 0 2.885-.896 2.993-1.877L8 19V8h12V7h-9V5h11zM10.254 36.246l-.707.707-5.07-5.07.706-.706zm3.38-.86-.707.708-7.59-7.59.707-.707zM42 36H29.76A3.76 3.76 0 0 1 26 32.24V13h16zm-14-3.76c0 .923.712 1.68 1.616 1.754l.144.006H40V15H28zM36 26l3-.5-5 7.5 1-5.5-3 .5 5-7zm-21.506 6.007-.708.707-5.07-5.07.708-.707zM10 19.08l-.005.1a1.74 1.74 0 0 0 1.732 1.914l.173-.009.17-.003a1.81 1.81 0 0 0 1.926-1.614 3 3 0 0 1-.004-.182L14 19.08V10h-4zm5.998-.07.009.206q0 .105-.004.21c.033.355.173.692.404.966l.116.124a1.75 1.75 0 0 0 1.214.496l.17-.008h.194a1.73 1.73 0 0 0 1.383-.48c.326-.318.512-.75.52-1.253l-.004-.19V10h-4zM35 20h-6v-1h6zm-1-2h-5v-1h5z"
  })));
};

export { IconSmallBusinessElectricity, IconSmallBusinessElectricity as default };
